import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Box, Drawer, DrawerOverlay,
  Image, Link,
  Stack, Text, Spacer
} from '@chakra-ui/react'
import {
  DirectionIcon,
  EventMarkerIcon,
  GlobeEventIcon,
  MarkerGenericIcon,
  ShareEventIcon,
  TagIcon,
  AffinityIcon
} from 'assets/icons'
import { LoadingSpinier } from 'common/Loading'
import {
  authSelectors,
  markersSelectors,
  openEventPane,
  setBlogLinkToBeCopied,
  setEventId,
  setEventMarkerUpdate,
  setOpenChatModal,
  setSelectedEventData,
  setSharingToFriends,
  usersSelectors,
  setHideNotification,
  setHideChat,
  setCloseAllDrawers,
  setEventData,
  toggleImageCarousel
} from 'store'
import {
  MonthName, REJECTED, SUCCEEDED, PENDING
} from 'utils/constants'
import { convertToOwnTimeZoneEvent, isAuth, showCoordParams } from 'utils/helpers'

import { StyledModalContainer } from './styled'

export const EventPane = () => {
  const dispatch = useDispatch()
  const {
    eventData, getEventDataStatus, selectedEventData, isEventPaneOpen
  } = useSelector(markersSelectors)
  const { activeProfile, closeAllDrawers, getUserProfileStatus } = useSelector(usersSelectors)
  const { signInStatus } = useSelector(authSelectors)

  const drawerRef = useRef()
  const isLoggedIn = signInStatus === SUCCEEDED || isAuth()
  const [searchParams, setSearchParams] = useSearchParams()

  const getDrawerHeight = () => (window.innerHeight - 120) + 'px'
  // const modalBlogDrawer = document.querySelector('#chakra-modal-blog-drawer')
  const customPopupOverlay = document.querySelector('#custom-popup-overlay-event')

  const [animateOut, setAnimateOut] = useState(false)
  const [directionAddress, setDirectionAddress] = useState('')
  const [localHidePanel, setLocalHidePanel] = useState(false)

  // getting date and time from data
  const start_date = convertToOwnTimeZoneEvent(eventData?.start_date)
  const end_date = convertToOwnTimeZoneEvent(eventData?.end_date)
  // const month1 = MonthName[start_date.getMonth()]
  // const month2 = MonthName[end_date.getMonth()]
  const month1 = start_date.getMonth()
  const month2 = end_date.getMonth()
  const day1 = start_date.getDate()
  const day2 = end_date.getDate()
  const year1 = start_date.getFullYear()
  const year2 = end_date.getFullYear()
  const daterange = year1 + '.' + month1 + '.' + day1 + ' / ' + year2 + '.' + month2 + '.' + day2
  const directionButtonText = 'Direction (Maps)'
  const ticketButtonText = 'Tickets (Discount)'
  const month = start_date.getMonth()
  const monthNumber = month.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })
  const idText = eventData?.id.toLocaleString('en-US', {
    minimumIntegerDigits: 3,
    useGrouping: false
  })
  // const websitename = eventData?.website.replace(/^https?:\/\//i, '').split('/')[0]
  const deviceSpec = navigator.userAgent

  const decimalToDMS = (decimal, type) => {
    // eslint-disable-next-line no-nested-ternary
    const dir = type === 'lat'
      ? (decimal >= 0 ? 'N' : 'S')
      : (decimal >= 0 ? 'E' : 'W')

    const abs = Math.abs(decimal)
    const deg = Math.floor(abs)
    const minFloat = (abs - deg) * 60
    const min = Math.floor(minFloat)
    const sec = ((minFloat - min) * 60).toFixed(2)

    return `${deg}°${min}'${sec}"${dir}`
  }

  const convertedCoordinates = () => {
    const lat = eventData?.lat
    const lng = eventData?.lng
    let convertedLat = decimalToDMS(lat, 'lat')
    let convertedLng = decimalToDMS(lng, 'lng')
    return convertedLat + ' ' + convertedLng
  }

  useEffect(() => {
    if (deviceSpec.includes('iPhone')
      || deviceSpec.includes('Mac')
      || deviceSpec.includes('iPad')
    ) {
      if (eventData?.address !== null && eventData?.address !== '') {
        setDirectionAddress(`http://maps.apple.com/?daddr=${encodeURIComponent(eventData?.address)}`)
      } else if (eventData?.address === null || eventData?.address === '') {
        setDirectionAddress(`https://maps.apple.com/?daddr=${eventData?.lat},${eventData?.lng}`)
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (eventData?.address !== null && eventData?.address !== undefined) {
        setDirectionAddress(`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(eventData?.address)}`)
      } else if (eventData?.address === null || eventData?.address === '') {
        setDirectionAddress(`https://www.google.com/maps/dir/${activeProfile?.coordinates[0]},${activeProfile?.coordinates[1]}/${eventData?.lat},${eventData?.lng}`)
      }
    }
  }, [eventData?.address])

  const handleShare = (id) => {
    sessionStorage.setItem('isSharingBlog', 'true')
    window.dispatchEvent(new CustomEvent('isSharingBlog-changed'))
    // customPopupOverlay.click()

    setTimeout(() => {
      dispatch(setOpenChatModal(true))
      dispatch(setSharingToFriends(true))
      dispatch(setBlogLinkToBeCopied(window.location.origin
    + '/?eventid=' + id))
      setTimeout(() => dispatch(setOpenChatModal(false)), 300)
    }, customPopupOverlay ? 800 : 0)
  }

  const handleClosePopup = () => {
    localStorage.removeItem('id')
    sessionStorage.removeItem('eventid')
    dispatch(setSelectedEventData(null))
    setTimeout(() => {
      dispatch(setEventMarkerUpdate(true))
    }, 500)
    dispatch(setEventId(null))
  }

  const closeDrawer = () => {
    setAnimateOut(true)
    sessionStorage.removeItem('eventid')
    dispatch(setEventData())
    dispatch(setHideNotification(false))
    dispatch(setHideChat(false))
    setLocalHidePanel(true)

    setTimeout(() => {
      setAnimateOut(false)
      dispatch(openEventPane(false))
      setLocalHidePanel(false)

      setTimeout(() => {
        if (document.querySelectorAll('.chakra-modal__content').length === 0) {
          showCoordParams(setSearchParams)
        }
      }, 200)
    }, 750)
  }

  useEffect(() => {
    if (getEventDataStatus === REJECTED) {
      setTimeout(() => handleClosePopup(), 700)
    }
  }, [getEventDataStatus])

  useEffect(() => {
    if (
      isLoggedIn
      && getUserProfileStatus === SUCCEEDED
      && sessionStorage.getItem('eventid')
    ) {
      try {
        document.querySelector('button[name="profile-pane-back-btn"]').click()
      } catch {
        //
      }
    }
  }, [isLoggedIn, getUserProfileStatus])

  useEffect(() => {
    if (closeAllDrawers) {
      closeDrawer()
    }
  }, [closeAllDrawers])

  return (
    <Drawer
      id="event-drawer"
      finalFocusRef={drawerRef}
      isOpen={isEventPaneOpen}
      onClose={() => {
        if (isLoggedIn) {
          closeDrawer()
        }
      }}
      placement="bottom"
      size="sm"
      closeOnEsc={false}
      closeOnOverlayClick={isLoggedIn}
      boxShadow="2xl"
      blockScrollOnMount={false}
    >
      <DrawerOverlay
        zIndex="1300"
        background="transparent"
        onClick={() => {
          if (isLoggedIn) {
            dispatch(setCloseAllDrawers(true))
            setTimeout(() => dispatch(setCloseAllDrawers(false)), 750)
          }
        }}
      />
      {eventData === null || getEventDataStatus === PENDING ? (
        <StyledModalContainer
          initial={{
            width: '365px',
            height: animateOut ? getDrawerHeight() : '0px',
            y: 0
          }}
          style={{
            height: 'auto'
          }}
        >
          <Box width="100%" height="170px">
            <LoadingSpinier />
          </Box>
        </StyledModalContainer>
      ) : (
        <StyledModalContainer
          initial={{
            width: '365px',
            height: animateOut ? getDrawerHeight() : '0px',
            y: 0
          }}
          animate={{
            width: '365px',
            height: animateOut ? '0px' : getDrawerHeight()
          }}
          transition={{
            type: animateOut ? 'tween' : 'spring',
            stiffness: 200,
            damping: 22,
            duration: 0.7
          }}
          paddingBottom={localHidePanel || animateOut ? '0px' : '20px'}
          style={{
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          <Stack height="90px !important" className="event-popup-division" id="event-header-popup">
            <Stack
              height="90px !important"
              width="100%"
              padding="0px 0px"
              id="event-name-popup"
              style={{
                background: `url(${eventData?.background_image})`,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                backgroundOrigin: 'content-box'
              }}
            />

          </Stack>
          <Stack height="60px !important" className="event-popup-division" id="event-name-popup">
            <Text maxWidth="90%">{eventData?.name ? eventData?.name : 'Event Unavailable. Please refresh page.'}</Text>
            <Spacer />
            <Text className="event-id-text">{idText}</Text>
          </Stack>
          <Stack padding="0px 20px" className="event-popup-division" id="event-description-popup">
            <Stack className="event-division-item-wrapper-popup">
              <Text maxWidth="90%">{eventData?.description ? eventData?.description : 'No Description'}</Text>
            </Stack>
          </Stack>
          <Stack height="50px" className="event-popup-division" id="event-date-popup">
            <Box height="50px" className="event-division-item-wrapper-popup">
              <EventMarkerIcon start_date={monthNumber} color="#000" />
              <Text>{eventData?.start_date && eventData.end_date ? daterange : 'null'}</Text>
            </Box>
          </Stack>
          <Stack height="50px" className="event-popup-division" id="event-address-popup">
            <Box height="50px" className="event-division-item-wrapper-popup">
              <MarkerGenericIcon />
              <Text maxWidth="288px" marginY="5px !important">{eventData?.address === null || eventData?.address === '' ? convertedCoordinates() : eventData?.address}</Text>
            </Box>
          </Stack>
          <Stack height="50px" className="event-popup-division">
            <Box height="50px" className="event-division-item-wrapper-popup">
              <Link
                href={directionAddress}
                target="_blank"
                // pointerEvents="none"
                _cursor="pointer"
                style={{
                  textDecoration: 'none',
                  color: '#000'
                }}
              >
                <DirectionIcon />
                <Text color="#77b2d4">{directionButtonText}</Text>
              </Link>
            </Box>
          </Stack>
          {/* <Stack height="50px" className="event-popup-division">
            <Box height="50px" className="event-division-item-wrapper-popup">
              <Link
                href={eventData?.website}
                target="_blank"
                _cursor="pointer"
                style={{
                  textDecoration: 'none',
                  color: '#000'
                }}
              >
                <GlobeEventIcon />
                <Text maxWidth="288px">
                  {eventData?.website !== null || eventData?.website !== '' ? websitename : null}
                </Text>
              </Link>
            </Box>
          </Stack> */}
          <Stack height="50px" className="event-popup-division">
            <Link
              href={eventData?.affiliate_link}
              target="_blank"
              _cursor="pointer"
              style={{
                textDecoration: 'none',
                color: '#000'
              }}
            >
              <TagIcon />
              <Text color="#77b2d4">{ticketButtonText}</Text>
            </Link>
          </Stack>
          <Stack height="50px" className="event-popup-division">
            <Box
              height="50px"
              className="event-division-item-wrapper-popup"
              cursor="pointer"
              onClick={() => {
                if (eventData) {
                  handleShare(eventData.id)
                }
              }}
            >
              <ShareEventIcon />
              <Text color="#77b2d4">
                Share
              </Text>
            </Box>
          </Stack>
          <Stack className="event-popup-division">
            <Box
              height="50px"
              className="event-division-item-wrapper-popup"
            >
              <AffinityIcon />
              <Box className="event-popup-affinities-container">
                {eventData?.affinities}
              </Box>
            </Box>
          </Stack>
          <Stack id="event-popup-image-wrapper">
            <Stack id="event-popup-image">
              {eventData?.additional_images?.map((e, index) => (
                <Image
                  src={e}
                  maxWidth="320px"
                  borderRadius="5px"
                  onClick={() => {
                    dispatch(toggleImageCarousel(true))
                    localStorage.setItem('image-current-slide', index)
                  }}
                />
              ))}
            </Stack>
          </Stack>
        </StyledModalContainer>
      )}
    </Drawer>
  )
}
